"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
exports.kbFeatureKey = 'kb';
exports.defaultKbKey = 'de';
//# sourceMappingURL=kb.state.js.map